import axios, { AxiosResponse } from 'axios';
import { IDashboardResponse } from 'models/dashboard/i-dashboard.interface';

export const fetchDashboardData = (): Promise<AxiosResponse<IDashboardResponse>> =>
  axios.get<IDashboardResponse>('/api/v1/trades/dashboard/');
